import { apiCall, ApiConfig } from '../../config/api'
import { OrderOrigin } from '../../interfaces/OrderOrigin'
import { getOrderOriginsAction } from '../actions/orderOriginActions'
import { call, put, takeEvery } from '@redux-saga/core/effects'
import { AxiosError, AxiosResponse } from 'axios'
import { GET_ORDERORIGINS } from '../types/orderOriginActionsTypes'
import { DataGridElements } from '../../interfaces/index'

/*
Copyright 2022-07-12 por Alfonso Moya Ecomsur Holding S.A ©
Detalle: se módifica saga para solo obtener los orderOrigin activos
*/

export function* getOrderOriginsAsync() {
  try {
    const { status, data }: AxiosResponse<DataGridElements<OrderOrigin>> =
      yield call(
        apiCall,
        'GET',
        `${ApiConfig.OrderOriginApi}?pageSize=50&active=true`
      )
    if (status === 200) {
      yield put(getOrderOriginsAction(data.items))
    }
  } catch (error) {
    const serverError = error as AxiosError<string>
    yield put(getOrderOriginsAction([], serverError.message))
  }
}

export function* watchGetOrderOriginsAsync() {
  yield takeEvery(GET_ORDERORIGINS, getOrderOriginsAsync)
}
